import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import Card from 'components_v2/common/CardV2';
import ThumbCard from 'components_v2/common/ThumbCard';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import Link from 'components/Link';
import s from './Photo.scss';

class Photo extends React.Component {
  constructor() {
    super();
    this.state = {
      leadimgList: [],
      rdata: [],
      nextPageUrl: '',
      showLoadMore: true,
      leadCard: {},
      showLoader: false,
      leadIndexCounter: 0,
      leadImgWidth: 555,
      transform: 0,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    if (
      data &&
      typeof data.items !== 'undefined' &&
      Array.isArray(data.items) &&
      typeof data.items[0] !== 'undefined' &&
      typeof data.items[0].id !== 'undefined'
    ) {
      this.fetchLeadThumbList(data.items[0].id);
    }
    this.setLeadImgWidth();
    window.addEventListener('resize', this.setLeadImgWidth);
    window.intervalRef = setInterval(() => {
      this.animateLeadImg();
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(window.intervalRef);
  }

  static getDerivedStateFromProps(props, state) {
    const { data } = props;
    const nextPageUrl =
      typeof data !== 'undefined' &&
      typeof data.pagination !== 'undefined' &&
      typeof data.pagination.nextPageUrl !== 'undefined'
        ? data.pagination.nextPageUrl
        : '';
    if (Array.isArray(data.items)) {
      const leadCard = data.items[0];
      const rdata = data.items.filter((k, i) => i > 0);
      if (!state.rdata.length) {
        return { rdata, nextPageUrl, leadCard };
      }
      return null;
    }
    return null;
  }

  setLeadImgWidth = () => {
    const obj = document.querySelector('#photolistSlider');
    if (typeof obj !== 'undefined') {
      this.setState({
        leadImgWidth: obj.offsetWidth,
      });
    }
  };

  fetchLeadThumbList = msid => {
    const url = `/imglistfeedspadata.cms?feedtype=sjson&msid=${msid}`;
    makeRequest
      .get(url, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .catch(err => console.log(err))
      .then(data => {
        if (data && data.status === 200 && data.data) {
          this.setState({ leadimgList: data.data });
        }
      });
  };

  loadPaginationData = () => {
    const { nextPageUrl } = this.state;
    if (nextPageUrl !== '') {
      this.setState({ showLoader: true });
      makeRequest
        .get(nextPageUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
        .catch(err => console.log(err))
        .then(newsData => {
          const sectionitems =
            newsData &&
            newsData.status === 200 &&
            newsData.data &&
            Array.isArray(newsData.data.sectionitems) &&
            newsData.data.sectionitems.length &&
            newsData.data.sectionitems.filter(v => v && v.pagination);

          if (Array.isArray(sectionitems) && sectionitems.length) {
            const itemData = sectionitems[0];
            const { rdata } = this.state;
            // rdata.concat(newsData.data.sectionitems[0].items);
            if (
              (itemData &&
                typeof itemData.pagination !== 'undefined' &&
                itemData.pagination.nextPageUrl &&
                Array.isArray(itemData.items) &&
                itemData.items.length) ||
              (itemData &&
                typeof itemData.pagination !== 'undefined' &&
                itemData.pagination.isLoadMore)
            ) {
              this.setState({
                nextPageUrl: itemData.pagination.nextPageUrl,
              });
            } else {
              this.setState({ nextPageUrl: '', showLoadMore: false });
            }
            this.setState({
              rdata: [...rdata, ...itemData.items],
              showLoader: false,
            });
          }
        });
    }
  };

  animateLeadImg() {
    let { leadIndexCounter, transform } = this.state;
    const { leadimgList, leadImgWidth } = this.state;
    leadIndexCounter += 1;
    if (leadIndexCounter < leadimgList.length) {
      for (let i = 0; i < leadimgList.length; i += 1) {
        if (i === leadIndexCounter) {
          leadimgList[i].selected = 'yes';
          transform = -(leadImgWidth * i);
        } else {
          leadimgList[i].selected = '';
        }
      }
    }
    if (leadIndexCounter === leadimgList.length - 1) {
      leadIndexCounter = -1;
    }
    // creating new refrence so that component will re render
    const tempLeasImglist = JSON.parse(JSON.stringify(leadimgList));
    this.setState({
      leadimgList: tempLeasImglist,
      leadIndexCounter,
      transform,
    });
  }

  handleCardClick = index => {
    // changing the lead image if user clicks on thumb
    const { leadImgWidth, leadIndexCounter, leadimgList } = this.state;
    let { transform } = this.state;
    transform = -(index * leadImgWidth);
    if (typeof window.intervalRef !== 'undefined') {
      clearInterval(window.intervalRef);
    }
    if (leadIndexCounter < 0) {
      leadimgList[leadimgList.length - 1].selected = '';
    } else {
      leadimgList[leadIndexCounter].selected = '';
    }
    leadimgList[index].selected = 'yes';
    const tempLeasImglist = JSON.parse(JSON.stringify(leadimgList));
    this.setState({
      transform,
      leadimgList: tempLeasImglist,
      leadIndexCounter: index,
    });
    window.intervalRef = setInterval(() => {
      this.animateLeadImg();
    }, 5000);
  };

  render() {
    const { data } = this.props;
    const {
      rdata,
      leadimgList,
      showLoadMore,
      leadCard,
      showLoader,
      leadImgWidth,
      transform,
      nextPageUrl,
    } = this.state;
    if (typeof data === 'undefined' || typeof data.items === 'undefined') {
      return null;
    }
    return (
      <div className="Photolist_warpper">
        <div className="grid_wrapper topimgbox">
          <div className="col_l_10 col_m_12">
            <div id="photolistSlider" className={s.photolistbox}>
              <div
                className={`${s.photolistslideouter} ${
                  transform === 0 ? s.notransition : ''
                }`}
                style={{ transform: `translate3d(${transform}px,0,0)` }}
              >
                {leadCard &&
                  Array.isArray(leadimgList) &&
                  leadimgList.length === 0 && (
                    <div className={`${s.photolistslide}`}>
                      <Link
                        to={leadCard.wu}
                        data-newga={`Click-Photostory-0#${leadCard.wu}`}
                      >
                        {/* <a href={leadCard.wu}> */}
                        <div className={s.photolistcontent}>
                          <div className={s.content}>
                            <img
                              alt=""
                              width={leadImgWidth}
                              src={`https://static.toiimg.com/thumb/imgsize-${
                                leadCard.imagesize ? leadCard.imagesize : 1234
                              },msid-${
                                leadCard.imageid
                              },width-${leadImgWidth},resizemode-4/${
                                leadCard.imageid
                              }.jpg`}
                            />
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}
                {Array.isArray(leadimgList) &&
                  leadimgList.length > 0 &&
                  leadimgList.map(item => (
                    <div
                      className={`${s.photolistslide}`}
                      style={{ width: `${leadImgWidth}px` }}
                    >
                      <Link
                        to={item.wu}
                        data-newga={`Click-Photostory-0#${item.wu}`}
                      >
                        <div className={s.photolistcontent}>
                          <div className={s.content}>
                            <img
                              alt={item.hl}
                              width={leadImgWidth}
                              src={`https://static.toiimg.com/thumb/imgsize-${
                                item.imagesize ? item.imagesize : 1234
                              },msid-${
                                item.imageid
                              },width-${leadImgWidth},resizemode-4/${
                                item.imageid
                              }.jpg`}
                            />
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
              </div>
              {leadCard && (
                <div className={s.imgcaption}>
                  <a href={leadCard.wu}>
                    <i className={s.photolistthumbcount}>5</i>
                    <figcaption>{leadCard.hl}</figcaption>
                  </a>
                </div>
              )}
            </div>
          </div>
          <div
            className={`${s.photolistright} photolistright col_l_2 col_m_12`}
          >
            {Array.isArray(leadimgList) &&
              leadimgList.length > 0 && (
                <ul>
                  {leadimgList.map((item, index) => (
                    <ThumbCard
                      data={item}
                      index={index}
                      onClick={this.handleCardClick}
                    />
                  ))}
                </ul>
              )}
          </div>
        </div>
        <div className="photolistTwocards grid_wrapper">
          {rdata.map((item, index) => (
            <div className="col_l_6">
              <Card
                data={item}
                isVerticalTile
                isPhotoStory
                newga={`Click-Photostory-${index + 1}#${item.wu}`}
              />
            </div>
          ))}
        </div>
        {showLoader && (
          <div className={s.loaderouter}>
            <LoaderSpinner />
          </div>
        )}
        {showLoadMore &&
          nextPageUrl && (
            <button onClick={this.loadPaginationData} className={s.moreBtn}>
              Load More
            </button>
          )}
      </div>
    );
  }
}

Photo.propTypes = {
  data: PropTypes.shape({}),
  isMobile: PropTypes.bool,
};
Photo.defaultProps = {
  data: {},
  isMobile: false,
};
const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

export default connect(mapStateToProps)(Photo);
